<nav class="bottom-nav">
  <a class="bottom-nav__item" routerLink="/dashboard" routerLinkActive="bottom-nav__item--active">
    <span class="material-symbols-outlined">dashboard</span>
    <span>Inicio</span>
  </a>
  <a class="bottom-nav__item" routerLink="/booking" routerLinkActive="bottom-nav__item--active">
    <span class="material-symbols-outlined">calendar_today</span>
    <span>Reservar</span>
  </a>
  <a class="bottom-nav__item" routerLink="/my-appointments" routerLinkActive="bottom-nav__item--active">
    <span class="material-symbols-outlined">event_list</span>
    <span>Mis turnos</span>
  </a>
  <a class="bottom-nav__item" routerLink="/settings" routerLinkActive="bottom-nav__item--active">
    <span class="material-symbols-outlined">tune</span>
    <span>Config</span>
  </a>
</nav>
